define('models/PaymentGroupModel',[
    'underscore','backbone','ObjectModel','LocalStorage','app',
    'models/PaymentModeCollection'
],function (
        _,Backbone,ObjectModel,LocalStorage,app,
        PaymentModeCollection
    ) {
    //
    // Model PaymentGroup
    //
    var VAD = 'vad',
        VAE = 'vae';

    var PaymentGroupModelPrototype = {
        
        name:'PaymentGroupModel',
        route:'apiPaymentGroupModel',
        idAttribute:'id_payment_group',
        defaults:{
            vae:false,
            vad:false,
        },
        
        initialize:function(){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,arguments);
            //
            model.payment_modes = new PaymentModeCollection();
        },

        setup:function(){
            var model = this;
            // ajouté uniquement pour les modèles globaux
            // les modèle par boutique sont ajouté sur store.getPaymentGroups()
            _(model.get('payment_modes')).each(function(id_payment_mode){
                var paymentMode = app.getPaymentMode(id_payment_mode);
                if(paymentMode) model.addPaymentMode(paymentMode);
            });
        },

        addPaymentMode:function(paymentMode){
            var model = this,
                isVae = model.get(VAE),
                isVad = model.get(VAD),
                pmVae = paymentMode.get(VAE),
                pmVad = paymentMode.get(VAD);
            model.set(VAE,isVae || pmVae);
            model.set(VAD,isVad || pmVad);
            model.payment_modes.add(paymentMode);
        },

        isAvailable:function(vad){
            return this.get(vad?VAD:VAE);
        },

        getPaymentModes:function(){
            return this.payment_modes;
        },

        getPaymentMode:function(id_payment_mode){
            return this.payment_modes.get(id_payment_mode+'');
        }

    };

    var PaymentGroupModel = ObjectModel.extend(LocalStorage).extend(PaymentGroupModelPrototype);
    
    return PaymentGroupModel;
});
